<template>
  <transition name="fade">
    <NewPassword />
  </transition>
</template>

<script>
import ValidationMixin from '@/mixins/ValidationMixin.js';
import NewPassword from '@/components/NewPassword';

export default {

  components: { NewPassword },

  mixins: [ValidationMixin],

};
</script>

<style>

</style>
